import { CanActivateFn } from '@angular/router';
import { permissionGuard } from '../../../core/guards/permission.guard';
import { FeatureName } from '../../../../@backoffice/services/permission.service';

/**
 * Require `edit` to open the wizard on a campaign that does not exist yet.
 *
 * `new` is a *value* of the wizard's `:campaignId` segment rather than a route of its own, so
 * one shell serves both creating and editing — which is what makes adopting a freshly minted id
 * a parameter change instead of a teardown. The two cases do not want the same permission
 * though: viewing an existing campaign needs only `read` (that is how "View Details" reaches
 * Review for a read-only user), while creating one is an edit.
 *
 * The shell therefore asks for `read`, and this adds the stricter half back for `/campaigns/new/…`
 * — restoring exactly what the separate `campaigns/new` route used to enforce with its own
 * `edit` guard. The editable steps keep their own `edit` guards either way; this is about the
 * one step that has none, Review, which a read-only user may legitimately open on a real
 * campaign but has no business opening on an unborn one.
 */
export const newCampaignRequiresEditGuard: CanActivateFn = (route, state) =>
  route.paramMap.get('campaignId') === 'new'
    // A campaign starts with its Basic Info save, so creating one needs Basic Info edit
    // (which the Roles page only grants together with Card Setup, Earning Rules and Promotions edit).
    ? permissionGuard(FeatureName.CAMPAIGN_BASIC_INFO, 'edit')(route, state)
    : true;
